"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTreeController = exports.TotalCountForGroupMap = exports.TotalCountForNodeMap = exports.ItemColsForNodeMap = exports.ItemsForNodeMap = exports.AggsForNodeMap = exports.GroupsForGroupByMap = exports.GroupsForNodeMap = exports.GroupColsForGroupByMap = exports.GroupsByIdMap = exports.NodesByKeyMap = void 0;
const AggregationType_1 = __importDefault(require("@opsbase/lib-data-aggregation/AggregationType"));
const getEmptyGroupCollection_1 = __importDefault(require("@opsbase/lib-data-element/GroupCollection/getEmptyGroupCollection"));
const mergeItemCollections_1 = __importDefault(require("@opsbase/lib-data-element/helpers/mergeItemCollections"));
const getEmptyItemCollection_1 = __importDefault(require("@opsbase/lib-data-element/ItemCollection/getEmptyItemCollection"));
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const consts_1 = require("@opsbase/lib-data-query/consts");
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const react_1 = __importStar(require("react"));
const uuid = __importStar(require("uuid"));
const AggsLoader_1 = __importDefault(require("../AggsLoader"));
const GroupsLoaderRegistry_1 = __importDefault(require("../GroupsLoaderRegistry"));
const calcIsHighlighting_1 = __importDefault(require("../helpers/calcIsHighlighting"));
const ItemsLoader_1 = __importDefault(require("../ItemsLoader"));
const DataTreeContext_1 = __importDefault(require("../useDataTree/DataTreeContext"));
const DataTreeActionsContext_1 = __importDefault(require("../useDataTreeActions/DataTreeActionsContext"));
class NodesByKeyMap extends Map {
}
exports.NodesByKeyMap = NodesByKeyMap;
class GroupsByIdMap extends Map {
}
exports.GroupsByIdMap = GroupsByIdMap;
class GroupColsForGroupByMap extends Map {
}
exports.GroupColsForGroupByMap = GroupColsForGroupByMap;
class GroupsForNodeMap extends Map {
}
exports.GroupsForNodeMap = GroupsForNodeMap;
class GroupsForGroupByMap extends Map {
}
exports.GroupsForGroupByMap = GroupsForGroupByMap;
class AggsForNodeMap extends Map {
}
exports.AggsForNodeMap = AggsForNodeMap;
class ItemsForNodeMap extends Map {
}
exports.ItemsForNodeMap = ItemsForNodeMap;
class ItemColsForNodeMap extends Map {
}
exports.ItemColsForNodeMap = ItemColsForNodeMap;
class TotalCountForNodeMap extends Map {
}
exports.TotalCountForNodeMap = TotalCountForNodeMap;
class TotalCountForGroupMap extends Map {
}
exports.TotalCountForGroupMap = TotalCountForGroupMap;
function getUniqItems(ics) {
    return (0, uniqBy_1.default)((0, flatten_1.default)(ics.map(ic => ic.items)), item => item.id);
}
function getTotalCount(ics) {
    return ics.reduce((p, c) => p + c.totalCount, 0);
}
function getInitialStatus() {
    return {
        loading: true,
        loadingItems: true,
        loadingAggs: true,
        loadingGroups: true,
        autoExpanded: false,
        itemsLastLoaded: new Date(),
        aggsLastLoaded: new Date(),
        groupsLastLoaded: new Date(),
    };
}
function aggregateTheAggs(aggs) {
    const aggsByFieldKey = (0, groupBy_1.default)(aggs, agg => agg.fieldKey);
    return Object.keys(aggsByFieldKey).map((fieldKey) => {
        const a = aggsByFieldKey[fieldKey];
        let value = 0;
        switch (a[0].aggType) {
            case AggregationType_1.default.SWING:
            case AggregationType_1.default.AVG:
                value = a.reduce((p, c) => p + c.value, 0) / a.length;
                break;
            case AggregationType_1.default.SUM:
            case AggregationType_1.default.COUNT:
                value = a.reduce((p, c) => p + c.value, 0);
                break;
            case AggregationType_1.default.MIN:
                value = a.reduce((p, c) => (p > 0 ? Math.min(p, c.value) : 0), 0);
                break;
            case AggregationType_1.default.MAX:
                value = a.reduce((p, c) => Math.max(p, c.value), 0);
                break;
        }
        return { value, fieldKey };
    });
}
function matchGroupBys(a, b) {
    if ((a === null || a === void 0 ? void 0 : a.length) !== (b === null || b === void 0 ? void 0 : b.length))
        return false;
    return a.every(agb => b.find(bgb => bgb === agb));
}
function matchGroup(a, b) {
    return a.queryFieldKey === b.queryFieldKey && a.id === b.id;
}
function DataTreeController(props) {
    var _a;
    const { children, viewId, baseFilter, accumulativePaging = false, // When a new page is loaded it is APPENDED to the existing set of data
    startExpanded = false, hideIfEmpty = false, disableLazyLoading = false, pageSize = consts_1.DataPageSize, } = props;
    const [changed, setChanged] = (0, react_1.useState)();
    const view = (0, useView_1.default)(viewId);
    // Internal Data
    const lastChanged = (0, react_1.useRef)();
    const hasAggs = (0, react_1.useRef)();
    const expansionDepth = (0, react_1.useRef)(0);
    const expandedGroups = (0, react_1.useRef)([]);
    const forceDataLoaderRender = (0, react_1.useRef)();
    const groupBys = (0, react_1.useRef)();
    const allAggs = (0, react_1.useRef)();
    const allLeafNodes = (0, react_1.useRef)();
    // Controlled Data
    const dataStatus = (0, react_1.useRef)();
    const rootNode = (0, react_1.useRef)();
    const nodesByKey = (0, react_1.useRef)();
    const groupsForNode = (0, react_1.useRef)();
    const groupColsForGroupBy = (0, react_1.useRef)();
    const groupsForGroupBy = (0, react_1.useRef)();
    const groupsById = (0, react_1.useRef)();
    const aggsForNode = (0, react_1.useRef)();
    const itemsForNode = (0, react_1.useRef)();
    const itemColsForNode = (0, react_1.useRef)();
    const totalCountForNode = (0, react_1.useRef)();
    const totalCountForGroup = (0, react_1.useRef)();
    const hideChildren = !!hideIfEmpty && !((_a = totalCountForNode === null || totalCountForNode === void 0 ? void 0 : totalCountForNode.current) === null || _a === void 0 ? void 0 : _a.get(rootNode === null || rootNode === void 0 ? void 0 : rootNode.current));
    const addNode = (0, react_1.useMemo)(() => (n = {}) => {
        var _a, _b, _c, _d;
        const dn = n;
        dn.nodeKey = (_a = dn.nodeKey) !== null && _a !== void 0 ? _a : uuid.v4();
        dn.childNodes = dn.childNodes || [];
        dn.expanded = (_b = dn.expanded) !== null && _b !== void 0 ? _b : false;
        dn.highlighted = (_c = dn.highlighted) !== null && _c !== void 0 ? _c : false;
        dn.page = (_d = dn.page) !== null && _d !== void 0 ? _d : 0;
        if (dn.parentNode)
            dn.parentNode.childNodes.push(dn);
        if (dn.group)
            groupsById.current.set(dn.group.id, dn.group);
        nodesByKey.current.set(dn.nodeKey, dn);
        itemsForNode.current.set(dn, []);
        itemColsForNode.current.set(dn, []);
        totalCountForNode.current.set(dn, 0);
        return dn;
    }, []);
    // Re-initialize Data Whenever the View changes significantly
    if (!matchGroupBys(view === null || view === void 0 ? void 0 : view.groupBys, groupBys.current) ||
        lastChanged.current < view.groupsChanged ||
        lastChanged.current < view.fieldsChanged || // (Needed for adding new group totals)
        lastChanged.current < view.highlightsChanged || // (Needed for adding new group totals)
        lastChanged.current < view.filtersChanged // Needed for paging
    ) {
        lastChanged.current = new Date();
        hasAggs.current = !!MetaModelRegistry_1.default[view.type].aggQueryName && !!view.groupBys.length;
        dataStatus.current = getInitialStatus();
        groupBys.current = [...view.groupBys];
        allAggs.current = [];
        nodesByKey.current = new NodesByKeyMap();
        groupColsForGroupBy.current = new GroupColsForGroupByMap();
        groupsById.current = new GroupsByIdMap();
        groupsForGroupBy.current = new GroupsForGroupByMap();
        groupsForNode.current = new GroupsForNodeMap();
        aggsForNode.current = new AggsForNodeMap();
        itemsForNode.current = new ItemsForNodeMap();
        itemColsForNode.current = new ItemColsForNodeMap();
        totalCountForNode.current = new TotalCountForNodeMap();
        totalCountForGroup.current = new TotalCountForGroupMap();
        rootNode.current = addNode();
        rootNode.current.expanded = true;
        // INIT WITHOUT GROUPING
        if (groupBys.current.length === 0) {
            dataStatus.current.loadingGroups = false;
            dataStatus.current.loadingAggs = false;
            dataStatus.current.aggsLastLoaded = new Date();
            dataStatus.current.groupsLastLoaded = new Date();
            rootNode.current.itemCollection = (0, getEmptyItemCollection_1.default)();
            allLeafNodes.current = [rootNode.current];
        }
        // INIT WITH GROUPING
        else {
            allLeafNodes.current = [];
            groupBys.current.forEach(gb => {
                groupColsForGroupBy.current.set(gb, (0, getEmptyGroupCollection_1.default)());
            });
        }
        forceDataLoaderRender.current = new Date();
        setChanged(new Date());
    }
    (0, react_1.useEffect)(() => {
        Array.from(nodesByKey.current.values()).forEach(node => {
            node.highlighted = (0, calcIsHighlighting_1.default)(view.highlightedGroups, node);
        });
        setChanged(new Date());
    }, [view.highlightedGroups]);
    const clearTotalCountsForGroups = (0, react_1.useCallback)(() => {
        Array.from(groupsById.current.values()).forEach(group => {
            totalCountForGroup.current.set(group, 0);
        });
    }, []);
    // const autoExpandGroups = useMemo(
    // 	() => (node: DataTreeNode) => {
    // 		// IF we only have one child group, we should expand
    // 		if (!!node.childNodes.length) {
    // 			if (node.childNodes.length === 1) node.expanded = true
    // 			node.childNodes.forEach(childNode => autoExpandGroups(childNode))
    // 		} else if (node.parentNode) {
    // 			// Never expand an empty group
    // 			if (!node.itemCollection?.items?.length) return
    //
    // 			// Of if we are an only child
    // 			const siblings = node.parentNode.childNodes
    // 			if (siblings.length === 1) return (node.expanded = true)
    //
    // 			// Or if we are an only VISIBLE child
    // 			if (view.hideEmptyGroups) {
    // 				const siblingsWithItems = siblings.filter(
    // 					sibling => sibling.itemCollection?.items?.length || 0
    // 				)
    // 				if (siblingsWithItems.length === 1) return (node.expanded = true)
    // 			}
    // 		}
    // 	},
    // 	[view.hideEmptyGroups]
    // )
    const autoCollapseGroups = (0, react_1.useMemo)(() => (node) => {
        node.expanded = false;
        if (!!node.childNodes.length)
            node.childNodes.forEach(autoCollapseGroups);
    }, []);
    const autoExpandGroups = (0, react_1.useMemo)(() => (node) => {
        node.expanded = true;
        if (!!node.childNodes.length)
            node.childNodes.forEach(autoExpandGroups);
    }, []);
    const populateAggData = (0, react_1.useMemo)(() => (node) => {
        var _a;
        let aggs;
        let totalCount = 0;
        if (!!node.childNodes.length) {
            node.childNodes.forEach(populateAggData);
            aggs = aggregateTheAggs((0, flatten_1.default)(node.childNodes.map(childNode => aggsForNode.current.get(childNode))));
            totalCount += node.childNodes
                .map(childNode => totalCountForNode.current.get(childNode))
                .reduce((p, c) => p + c, 0);
        }
        else {
            const groups = groupsForNode.current.get(node);
            aggs = allAggs.current.filter(agg => {
                if ((groups === null || groups === void 0 ? void 0 : groups[0]) !== agg.dim1)
                    return false;
                return !((groups === null || groups === void 0 ? void 0 : groups.length) === 2 && (groups === null || groups === void 0 ? void 0 : groups[1]) !== agg.dim2);
            });
            totalCount += ((_a = aggs.find(agg => agg.aggType === AggregationType_1.default.COUNT)) === null || _a === void 0 ? void 0 : _a.value) || 0;
        }
        aggsForNode.current.set(node, aggs);
        totalCountForNode.current.set(node, totalCount);
        totalCountForGroup.current.set(node.group, totalCountForGroup.current.get(node.group) + totalCount);
    }, []);
    const populateItemData = (0, react_1.useMemo)(() => (node) => {
        var _a, _b;
        let ics = [];
        if (!!node.childNodes.length) {
            node.childNodes.forEach(populateItemData);
            ics = (0, flatten_1.default)(node.childNodes.map(childNode => itemColsForNode.current.get(childNode)));
        }
        else if ((_b = (_a = node.itemCollection) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) {
            ics = [node.itemCollection];
        }
        itemColsForNode.current.set(node, ics);
        itemsForNode.current.set(node, getUniqItems(ics));
        if (!hasAggs.current) {
            const totalCount = getTotalCount(ics);
            totalCountForNode.current.set(node, totalCount);
            totalCountForGroup.current.set(node.group, totalCountForGroup.current.get(node.group) + totalCount);
        }
    }, []);
    const populateGroupData = (0, react_1.useMemo)(() => () => {
        // TWO DIMENSIONAL GROUPING
        if (groupBys.current.length === 2) {
            groupColsForGroupBy.current.get(groupBys.current[0]).groups.forEach(group => {
                const parentNode = addNode({
                    group,
                    parentNode: rootNode.current,
                    expanded: !!expandedGroups.current.find(g => matchGroup(g, group)),
                });
                groupsForNode.current.set(parentNode, [group]);
                groupColsForGroupBy.current
                    .get(groupBys.current[1])
                    .groups.forEach(subGroup => {
                    const leafNode = addNode({
                        group: subGroup,
                        parentNode,
                        itemCollection: (0, getEmptyItemCollection_1.default)(),
                        expanded: !!expandedGroups.current.find(g => matchGroup(g, subGroup)),
                    });
                    groupsForNode.current.set(leafNode, [group, subGroup]);
                    allLeafNodes.current.push(leafNode);
                });
            });
        }
        // ONE DIMENSIONAL GROUPING
        else if (groupBys.current.length === 1) {
            groupColsForGroupBy.current.get(groupBys.current[0]).groups.forEach(group => {
                const leafNode = addNode({
                    group,
                    parentNode: rootNode.current,
                    itemCollection: (0, getEmptyItemCollection_1.default)(),
                    expanded: startExpanded ||
                        !!expandedGroups.current.find(g => matchGroup(g, group)),
                });
                allLeafNodes.current.push(leafNode);
                groupsForNode.current.set(leafNode, [group]);
            });
        }
    }, [addNode, startExpanded]);
    const processExpandToDepth = (0, react_1.useMemo)(() => (node, depth = 0) => {
        if (depth <= expansionDepth.current) {
            node.expanded = true;
            node.childNodes.forEach(childNode => processExpandToDepth(childNode, depth + 1));
        }
    }, []);
    const expandToDepth = (0, react_1.useMemo)(() => (diff) => {
        Array.from(nodesByKey.current.values()).forEach(node => (node.expanded = false));
        expansionDepth.current += diff;
        processExpandToDepth(rootNode.current);
        setChanged(new Date());
    }, [processExpandToDepth]);
    const toggleExpandNode = (0, react_1.useMemo)(() => (node) => {
        node.expanded = !node.expanded;
        if (node.group && node.expanded) {
            expandedGroups.current.push(node.group);
        }
        else if (node.group && !node.expanded) {
            expandedGroups.current = expandedGroups.current.filter(g => g === node.group);
        }
        setChanged(new Date());
    }, []);
    const changeNodePage = (0, react_1.useMemo)(() => (node, change) => {
        node.page += change;
        node.itemCollection.loading = true;
        dataStatus.current.loadingItems = true;
        dataStatus.current.loading = true;
        setChanged(new Date());
    }, []);
    const setGroupCollectionForGroupBy = (0, react_1.useMemo)(() => (forGroupBy, groupCollection) => {
        groupColsForGroupBy.current.set(forGroupBy, groupCollection);
        groupsForGroupBy.current.set(forGroupBy, groupCollection.groups || []);
        // IF ALL GROUPS ARE NOW LOADED, we should set the group tree
        if (!Array.from(groupColsForGroupBy.current.values()).some(gc => gc.loading)) {
            populateGroupData();
            dataStatus.current.groupsLastLoaded = new Date();
            dataStatus.current.loadingGroups = false;
            forceDataLoaderRender.current = new Date();
            setChanged(new Date());
        }
        else if (!dataStatus.current.loading) {
            dataStatus.current.loading = true;
            dataStatus.current.loadingGroups = true;
            dataStatus.current.loadingAggs = true;
            dataStatus.current.loadingItems = true;
            setChanged(new Date());
        }
    }, [populateGroupData]);
    const setAggCollection = (0, react_1.useMemo)(() => (aggCollection) => {
        if (!aggCollection.loading) {
            allAggs.current = aggCollection.aggs;
            clearTotalCountsForGroups();
            populateAggData(rootNode.current);
            dataStatus.current.aggsLastLoaded = new Date();
            dataStatus.current.loadingAggs = false;
            forceDataLoaderRender.current = new Date();
            setChanged(new Date());
        }
    }, [clearTotalCountsForGroups, populateAggData]);
    const setItemCollectionForNode = (0, react_1.useMemo)(() => (node, itemCollection) => {
        if (accumulativePaging) {
            node.itemCollection = (0, mergeItemCollections_1.default)(node.itemCollection, itemCollection);
        }
        else {
            node.itemCollection = itemCollection;
        }
        if (!allLeafNodes.current.some(ln => { var _a; return (_a = ln.itemCollection) === null || _a === void 0 ? void 0 : _a.loading; })) {
            if (!hasAggs.current)
                clearTotalCountsForGroups();
            const noOfVisibleGroups = Array.from(nodesByKey.current.values()).reduce((p, c) => {
                var _a, _b;
                if ((_a = c.childNodes) === null || _a === void 0 ? void 0 : _a.length)
                    return p;
                if (!view.hideEmptyGroups)
                    return p + 1;
                return p + (!!((_b = c === null || c === void 0 ? void 0 : c.itemCollection) === null || _b === void 0 ? void 0 : _b.totalCount) ? 1 : 0);
            }, 0);
            populateItemData(rootNode.current);
            if (!dataStatus.current.autoExpanded) {
                if (noOfVisibleGroups > 5) {
                    autoCollapseGroups(rootNode.current);
                }
                else {
                    autoExpandGroups(rootNode.current);
                }
                dataStatus.current.autoExpanded = true;
            }
            dataStatus.current.itemsLastLoaded = new Date();
            dataStatus.current.loadingItems = false;
            dataStatus.current.aggsLastLoaded = new Date();
            dataStatus.current.loadingAggs = false;
            dataStatus.current.loading = false;
            setChanged(new Date());
        }
        else if (!dataStatus.current.loading) {
            dataStatus.current.loading = true;
            dataStatus.current.loadingItems = true;
            setChanged(new Date());
        }
    }, [
        accumulativePaging,
        clearTotalCountsForGroups,
        populateItemData,
        view.hideEmptyGroups,
        autoCollapseGroups,
        autoExpandGroups,
    ]);
    // CONTEXTS
    const ctx = (0, react_1.useMemo)(() => ({
        viewId,
        pageSize,
        baseFilter: baseFilter,
        dataStatus: dataStatus.current,
        rootNode: rootNode.current,
        nodesByKey: nodesByKey.current,
        groupsForNode: groupsForNode.current,
        groupsForGroupBy: groupsForGroupBy.current,
        groupsById: groupsById.current,
        aggsForNode: aggsForNode.current,
        itemsForNode: itemsForNode.current,
        itemCollectionsForNode: itemColsForNode.current,
        totalCountForNode: totalCountForNode.current,
        totalCountForGroup: totalCountForGroup.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [changed]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        setGroupCollectionForGroupBy,
        setAggCollection,
        setItemCollectionForNode,
        toggleExpandNode,
        expandToDepth,
        changeNodePage,
    }), [
        changeNodePage,
        expandToDepth,
        setGroupCollectionForGroupBy,
        setAggCollection,
        setItemCollectionForNode,
        toggleExpandNode,
    ]);
    // Data Loaders
    // NOTE: This is purposely set to update whenever the GroupBys change or the groups
    // have all been loaded
    const dataLoaders = (0, react_1.useMemo)(() => {
        if (!forceDataLoaderRender.current)
            return null;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            // LOAD GROUPS
            dataStatus.current.loadingGroups &&
                groupBys.current.map(gb => {
                    const queryField = QueryFieldRegistry_1.default[gb.queryFieldKey];
                    const GroupsLoader = GroupsLoaderRegistry_1.default[queryField.fieldType];
                    return react_1.default.createElement(GroupsLoader, { key: gb.queryFieldKey, groupBy: gb });
                }),
            // LOAD AGGREGATIONS
            hasAggs.current && !dataStatus.current.loadingGroups && react_1.default.createElement(AggsLoader_1.default, null),
            // LOAD ITEMS
            !dataStatus.current.loadingGroups &&
                (!hasAggs.current || !dataStatus.current.loadingAggs) &&
                allLeafNodes.current.map(leafNode => (react_1.default.createElement(ItemsLoader_1.default, { key: leafNode.nodeKey, nodeKey: leafNode.nodeKey, noSkipping: disableLazyLoading || !hasAggs.current, pageSize: pageSize })))));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [forceDataLoaderRender.current, pageSize]);
    // Done
    return (0, react_1.useMemo)(() => (react_1.default.createElement(DataTreeActionsContext_1.default.Provider, { value: actionsCtx },
        react_1.default.createElement(DataTreeContext_1.default.Provider, { value: ctx },
            dataLoaders,
            !hideChildren && children))), [hideChildren, actionsCtx, children, ctx, dataLoaders]);
}
exports.DataTreeController = DataTreeController;
exports.default = DataTreeController;
